export default __webpack_public_path__ + "static/media/fenetre.ab013a39.jpg";